export default __webpack_public_path__ + "static/media/arrow_down.d9460608.svg";